import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    GamblingSafetyLink,
    GamblingSafetyScrollableContent,
    GamblingSafetyScrollableInner,
    GamblingSafetyTopBarWrapper,
    ManageLimitsLink,
} from './GamblingSafetyTopBar.style';
import { LogoTakeTimeToThink } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoTakeTimeToThink';
import { GambleAwareLogo } from 'src/domains/layouts/shared/assets/iconography/logos/responsible-gambling/GambleAwareLogo';
import { LogoGamblingHelpline } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamblingHelpline';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const GamblingSafetyTopBar = observer('GamblingSafetyTopBar', () => {
    const common = useCommon();
    const {
        footerSaferGamblingLogos: { takeTimeToThink },
        limitsAndResponsibleGambling,
    } = ConfigComponents.get(common).config;

    const gamblingSafetyLinks = (
        <>
            <GamblingSafetyLink
                href='https://www.gambleaware.org/'
                target='_blank'
                title='GambleAware'
            >
                <GambleAwareLogo />
            </GamblingSafetyLink>

            <GamblingSafetyLink
                href='https://www.gamcare.org.uk/get-support/talk-to-us-now/'
                target='_blank'
                title='GamCare'
            >
                <LogoGamblingHelpline />
            </GamblingSafetyLink>
            {takeTimeToThink === true ? (
                <GamblingSafetyLink
                    href='http://taketimetothink.co.uk/'
                    target='_blank'
                    title='Take time to think'
                >
                    <LogoTakeTimeToThink />
                </GamblingSafetyLink>
            ) : null}
        </>
    );

    return (
        <GamblingSafetyTopBarWrapper>
            <GamblingSafetyScrollableContent>
                <GamblingSafetyScrollableInner>{gamblingSafetyLinks}</GamblingSafetyScrollableInner>
            </GamblingSafetyScrollableContent>
            {limitsAndResponsibleGambling === true && common.session.isAuthorized ? (
                <ManageLimitsLink
                    to={{ account: 'limits' }}
                    dataTest='manage-limits'
                >
                    <I18n
                        langKey='gambling-safety-top-bar.manage-limits'
                        defaultText='Manage Limits'
                    />
                </ManageLimitsLink>
            ) : null}
        </GamblingSafetyTopBarWrapper>
    );
});
